import { render, staticRenderFns } from "./score-result-list-english.vue?vue&type=template&id=57a004d9"
import script from "./score-result-list-english.vue?vue&type=script&lang=js"
export * from "./score-result-list-english.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports